<template>
  <div class="w-full h-full">
    <div
      class="h-full justify-between flex flex-col duration-500 ease-in-out"
      :class="{ 'translate-y-[calc(100%-63px)]': animateOut }"
    >
      <div
        class="flex py-5 items-center justify-center w-full absolute -top-[50dvh]"
      >
        <svg
          aria-hidden="true"
          class="w-16 h-16 text-[#242c3b] animate-spin fill-primary-500"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
      </div>
      <div class="flex justify-center py-6 relative">
        <div
          class="w-full absolute bottom-0 left-0 pointer-events-none delay-300 duration-300"
          :class="{ 'opacity-0': !animateOut, 'opacity-5': animateOut }"
        >
          <img src="@/assets/images/backgrounds/register.webp" alt="" />
        </div>
        <div class="top-0 text-3xl font-bold relative">
          <div
            class="w-8 top-0 right-0 absolute translate-x-2/3 -translate-y-1/2"
          >
            <img
              src="@/assets/images/king-recharge-assets/crown-white.svg"
              class="w-full"
              alt=""
            />
          </div>
          <div>King Recharge</div>
        </div>
      </div>
      <div class="h-[15rem]">
        <div class="relative w-full h-full">
          <div
            class="absolute top-[65%] left-[5%] rotate-[-25deg] flex items-center justify-center w-0 h-0"
          >
            <div
              class="w-[25vw] min-w-[25vw] h-[25vw] relative flex items-center justify-center rounded-3xl bg-[#002E5E]"
            >
              <div
                class="absolute p-1 top-0 left-0 w-full h-full [&_*]:rounded-full [&_*]:bg-white [&_*]:bg-opacity-30 [&_*]:w-full [&_*]:h-full [&_*]:p-3"
              >
                <div class="">
                  <div class="">
                    <div class=""></div>
                  </div>
                </div>
              </div>

              <img
                src="~@/assets/images/all/bgStars.svg"
                class="object-contain w-full h-full absolute scale-[1.2]"
              />
              <img
                src="~@/assets/images/all/1xBetIco.svg"
                class="object-contain w-1/2 h-1/2 relative"
              />
            </div>
          </div>
          <div
            class="absolute top-[30%] left-[33%] rotate-[-10deg] flex items-center justify-center w-0 h-0"
          >
            <div
              class="w-[25vw] min-w-[25vw] h-[25vw] relative flex items-center justify-center rounded-3xl bg-[#1D7857]"
            >
              <div
                class="absolute p-1 top-0 left-0 w-full h-full [&_*]:rounded-full [&_*]:bg-white [&_*]:bg-opacity-30 [&_*]:w-full [&_*]:h-full [&_*]:p-3"
              >
                <div class="">
                  <div class="">
                    <div class=""></div>
                  </div>
                </div>
              </div>

              <img
                src="~@/assets/images/all/bgStars.svg"
                class="object-contain w-full h-full absolute scale-[1.2]"
              />
              <img
                src="~@/assets/images/all/betwinner.png"
                class="object-contain w-1/2 h-1/2 relative"
              />
            </div>
          </div>
          <div
            class="absolute top-[30%] right-[33%] rotate-[10deg] flex items-center justify-center w-0 h-0"
          >
            <div
              class="w-[25vw] min-w-[25vw] h-[25vw] relative flex items-center justify-center rounded-3xl bg-[#3A1E1E]"
            >
              <div
                class="absolute p-1 top-0 left-0 w-full h-full [&_*]:rounded-full [&_*]:bg-white [&_*]:bg-opacity-30 [&_*]:w-full [&_*]:h-full [&_*]:p-3"
              >
                <div class="">
                  <div class="">
                    <div class=""></div>
                  </div>
                </div>
              </div>

              <img
                src="~@/assets/images/all/bgStars.svg"
                class="object-contain w-full h-full absolute scale-[1.2]"
              />
              <img
                src="~@/assets/images/all/netflix.svg"
                class="object-contain w-1/2 h-1/2 relative"
              />
            </div>
          </div>
          <div
            class="absolute top-[65%] right-[5%] rotate-[25deg] flex items-center justify-center w-0 h-0"
          >
            <div
              class="w-[25vw] min-w-[25vw] h-[25vw] relative flex items-center justify-center rounded-3xl bg-[#55AD94]"
            >
              <div
                class="absolute p-1 top-0 left-0 w-full h-full [&_*]:rounded-full [&_*]:bg-white [&_*]:bg-opacity-30 [&_*]:w-full [&_*]:h-full [&_*]:p-3"
              >
                <div class="">
                  <div class="">
                    <div class=""></div>
                  </div>
                </div>
              </div>

              <img
                src="~@/assets/images/all/bgStars.svg"
                class="object-contain w-full h-full absolute scale-[1.2]"
              />
              <img
                src="~@/assets/images/all/usdtIcon.svg"
                class="object-contain w-1/2 h-1/2 relative"
              />
            </div>
          </div>
          <div
            class="absolute top-[90%] right-[50%] rotate-[0deg] flex items-center justify-center w-0 h-0"
          >
            <div
              class="w-[25vw] min-w-[25vw] h-[25vw] relative flex items-center justify-center rounded-3xl bg-[#0E4A7A]"
            >
              <div
                class="absolute p-1 top-0 left-0 w-full h-full [&_*]:rounded-full [&_*]:bg-white [&_*]:bg-opacity-30 [&_*]:w-full [&_*]:h-full [&_*]:p-3"
              >
                <div class="">
                  <div class="">
                    <div class=""></div>
                  </div>
                </div>
              </div>

              <img
                src="~@/assets/images/all/bgStars.svg"
                class="object-contain w-full h-full absolute scale-[1.2]"
              />
              <img
                src="~@/assets/images/all/prime-video.svg"
                class="object-contain w-1/2 h-1/2 relative"
              />
            </div>
          </div>
        </div>
      </div>
      <div></div>
      <div class="flex flex-col gap-8 text-center relative z-[2]">
        <div class="text-5xl font-bold">
          Dépots, retraits <br />
          & plus
        </div>
        <div class="text-xl px-6">
          Faites vos dépots et retraits rapide &bull; Relancez vos abonnements
          Netflix, Prime Vidéo, Disney plus, Spotify, ... &bull; Echangez vos
          crypto moins cher
        </div>
        <div class="flex justify-center w-full text-lg">
          <button @click="gotoLogin" class="text-md font-bold buttonComponent">Démarrer</button>
        </div>
        <div
          v-if="this.$IsIframe == false"
          class="flex justify-center w-full -mb-24"
        >
          <a
            href="https://web.kingrecharges.com/download/kingrecharge-latest.apk"
            target="_blank"
            class="!bg-[#242c3b] bg-none border buttonComponent gap-2  items-center flex"
          >
            <div class="w-6 h-6">
              <img src="@/assets/images/all/google-play.svg" alt="" />
            </div>
            <div>Télécharger sur Android</div>
          </a>
        </div>
      </div>
      <div class="relative bgGradientLight">
        <div class="w-full relative -top-[1px] left-0">
          <div class="h-[40px] w-full bottom-0">
            <div
              class="w-full h-full"
              style="
                background: radial-gradient(
                  circle at 50vw -1170px,
                  #242c3b 0%,
                  #242c3b 1200px,
                  #fff0 1202px,
                  #fff0 200vw
                );
              "
            ></div>
          </div>
        </div>
        <div class="text-center p-6">
          <!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores
          temporibus, perspiciatis consectetur exercitationem culpa quo quasi
          maxime dicta ratione. -->
        </div>
        <div class="py-2"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      animateOut: false,
    }
  },
  mounted() {},
  methods: {
    gotoLogin() {
      this.animateOut = true
      setTimeout(() => {
        document.body.style.removeProperty('background-color')
        document.body.classList.add('dark')
      }, 100)
      setTimeout(() => {
        this.$router.push('/login')
      }, 800)
    },
  },
}
</script>
